import * as React from 'react'

const FaqIcon = (props) => (
  <svg
    width={10}
    height={10}
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_81_1635)">
      <path
        d="M5.97855 7.14645L5.83211 7H5.625H1.875C1.08864 7 0.5 6.41136 0.5 5.625V1.875C0.5 1.08864 1.08864 0.5 1.875 0.5H8.125C8.91136 0.5 9.5 1.08864 9.5 1.875V5.625C9.5 6.41136 8.91136 7 8.125 7H7.625V7.5V8.79289L5.97855 7.14645Z"
        stroke="#545454"
      />
    </g>
    <defs>
      <clipPath id="clip0_81_1635">
        <rect width={10} height={10} fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default FaqIcon
